/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HTTP_ERROR } from '../constants/error';

export const ErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const getMessage = (err: HttpErrorResponse | null | undefined) => {
    const messages = err?.error?.errors?.[0]?.messages;
    if ((messages?.length ?? 0) > 0) return messages[0] ?? '';
    if (typeof err?.error?.error === 'string') return err.error.error;
    return '';
  };

  return next(req).pipe(
    // err is typed as nullable on purpose: an upstream source erroring with
    // null/undefined would otherwise throw a TypeError out of this handler,
    // which propagates downstream as a raw error and bypasses all handling.
    catchError((err: HttpErrorResponse | null | undefined) => {
      let error = '';

      switch (err?.status) {
        case 400:
          error = HTTP_ERROR.BAD_REQUEST;
          break;
        case 404:
          error = HTTP_ERROR.NOT_FOUND;
          break;
        case 500:
          error = HTTP_ERROR.SERVER_ERROR;
          break;
        default:
          if (err?.url == null) {
            error = HTTP_ERROR.URL;
          } else {
            error = err?.message || err?.statusText || '';
          }
          break;
      }

      const message =
        err?.status === 0
          ? 'Network error'
          : getMessage(err) || err?.statusText || '';
      const errorResponse = { error, message };
      return throwError(() => errorResponse);
    })
  );
};
